import React, { Component, useState, useRef, useEffect } from 'react';
import PaypalButton from './paypal';
import { PayPalButton } from 'react-paypal-button-v2';
import { withRouter } from 'react-router-dom';
import axios from './axios';
import Checkout from '../../Checkout';

function PaymentDetailsInput(props) {
	const [amount, setAmount] = useState('');
	const [clientId, setClient] = useState('');

	// axios
	// 	.post('/paymentRecords', { amount, clientId })
	// 	.then(res => {
	// 		console.log(res);
	// 	})
	// 	.catch(err => {
	// 		console.log(err);
	// 	});

	const [state, setstate] = useState();
	const [Address, setAddress] = useState();
	const [City, setCity] = useState();
	const [Country, setCountry] = useState();
	const [Card, setCard] = useState();
	const [Name, setName] = useState();
	const [State, setState] = useState();
	const [Zip, setZip] = useState();
	const [ExpiryDate, setExpiryDate] = useState();
	const [Cvv, setCvv] = useState();
	const onSuccess = payment => {
		console.log(payment);
	};

	const onCancel = data => {
		console.log(data);
	};

	const onError = err => {
		console.log(err);
	};

	return (
		<div className='contact-form--1'>
			<div className='container'>
				<div className='row row--35 align-items-start'>
					<div className='col-lg-12 order-2 order-lg-1'>
						<div className='section-title text-left mb--50'>
							<h2 className='title'>Payment Information</h2>
						</div>
						<div className='form-wrapper'>
							<form>
								<div class='row'>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item01'>
											<input
												type='text'
												name='address'
												id='item01'
												value={Address}
												onChange={e => {
													setAddress(e.target.value);
												}}
												placeholder='Address 1'
											/>
										</label>
									</div>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item02'>
											<input
												type='text'
												name='address'
												id='item02'
												value={Address}
												onChange={e => {
													setAddress(e.target.value);
												}}
												placeholder='Address 2'
											/>
										</label>
									</div>
								</div>
								<div class='row mb--20'>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item03'>
											<input
												type='text'
												name='city'
												id='item03'
												value={City}
												onChange={e => {
													setCity(e.target.value);
												}}
												placeholder='City'
											/>
										</label>
									</div>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item04'>
											<input
												type='text'
												name='zip'
												id='item04'
												value={Zip}
												onChange={e => {
													setZip(e.target.value);
												}}
												placeholder='Zip/Postal code'
											/>
										</label>
									</div>
								</div>
								<div class='row mb--20'>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item06'>
											<input
												type='text'
												name='country'
												id='item05'
												value={Country}
												onChange={e => {
													setCountry(e.target.value);
												}}
												placeholder='Country'
											/>
										</label>
									</div>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item05'>
											<input
												type='text'
												name='state'
												id='item07'
												value={State}
												onChange={e => {
													setState(e.target.value);
												}}
												placeholder='State'
											/>
										</label>
									</div>
								</div>
								<div class='row mb--20'>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item05'>
											<input
												type='text'
												name='card'
												id='item07'
												value={Card}
												onChange={e => {
													setCard(e.target.value);
												}}
												placeholder='Card #'
											/>
										</label>
									</div>

									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item05'>
											<input
												type='text'
												name='cvv'
												id='item07'
												value={Cvv}
												onChange={e => {
													setCvv(e.target.value);
												}}
												placeholder='CVV'
											/>
										</label>
									</div>
								</div>
								<div class='row mb--20'>
									<div class='col-lg-4 col-md-6 col-xs-6'>
										<label htmlFor='item05'>
											<input
												type='date'
												name='expiryDate'
												id='item07'
												value={ExpiryDate}
												onChange={e => {
													setExpiryDate(e.target.value);
												}}
												placeholder='Expiry Date'
											/>
										</label>
									</div>
								</div>

								{/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
								<div class='button text-center' style={{ width: '390px' }}>
									<PayPalButton
										amount={amount}
										// shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
										onSuccess={(details, data) => {
											alert('Transaction completed by ' + details.payer.name.given_name);

											setAmount(props.location.state.amount);
											setClient(props.location.state.clientId);
											axios
												.post('/paymentRecords', { amount, clientId })
												.then(res => {
													console.log(res);
												})
												.catch(err => {
													console.log(err);
												});

											// OPTIONAL: Call your server to save the transaction
											return fetch('/paypal-transaction-complete', {
												method: 'post',
												body: JSON.stringify({
													orderID: data.orderID,
												}),
											});
										}}
									/>
								</div>
							</form>
						</div>
					</div>
					  <div className="App">
                    <p className="App-intro">
                      <Checkout
                        name={'Your Company Name'}
                        description={'Item that you sold'}
                        amount={4.99}
                      />
                    </p>
                  </div>
					{/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={`${this.props.contactImages}`} alt="trydo"/>
                            </div>
                        </div> */}
				</div>
			</div>
		</div>
	);
}

export default withRouter(PaymentDetailsInput);
